import {
    IDatiqAutocomplete,
    IDatiqAutocompleteOption,
} from './datiq-autocomplete.interface';

import { DatiqAutocompleteType } from './datiq-autocomplete.enum';
import {
    datiqInputCreateId,
    DATIQ_DEFAULT_ID,
    DATIQ_DEFAULT_ARRAY,
    DATIQ_DEFAULT_STRING,
    DATIQ_INPUT_AUTOCOMPLETE,
} from '@dat/datiq-core/models';
export const DATIQ_AUTOCOMPLETE_ID: (id: string) => string = (id: string) =>
    datiqInputCreateId([id, DATIQ_INPUT_AUTOCOMPLETE]);

export const emptyDatiqAutocompleteOption: IDatiqAutocompleteOption = {
    id: DATIQ_DEFAULT_ID().substr(0, 8),
    display: DATIQ_DEFAULT_STRING,
    value: DATIQ_DEFAULT_STRING,
};

export const emptyDatiqAutocomplete: IDatiqAutocomplete = {
    options: DATIQ_DEFAULT_ARRAY as IDatiqAutocompleteOption[],
    selectedOptions: DATIQ_DEFAULT_ARRAY as IDatiqAutocompleteOption[],
    loaded: true,
    id: DATIQ_DEFAULT_ID().substr(0, 8),
    type: DatiqAutocompleteType.Standard,
};
